import instamapsBreadcrumbs from '../shared/components/breadcrumbs/breadcrumbs.vue';
import instamapsMessageModal from '../shared/components/message-modal/message-modal.vue';
import messages from './oblidat-translations';
import { OblidatService } from './services/oblidatService';

export default {
    name: 'instamapsOblidat',
    data: () => {
        return {     
            email: "",
            modalIsError: false,
            modalIsLoaded: false,
            modalTitle: "",
            modalMessage: "",
        };
    },
    i18n: {
        messages,
    },
    components: {
        instamapsBreadcrumbs,
        instamapsMessageModal,
    },
    props: {
		hasBreadcrumbs: { type: Boolean },
		selectedLang: { type: String }
    },
    methods: {
        recuperar: function() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    OblidatService.httpPostRemember(this.email, this.selectedLang).then((response) => {
                        if (response.status==="OK") {
                            this.showModalOK();
                        }else{
                            this.showModalError();
                        }
                    }).catch(() => {
                        this.showModalError();
                    });
                }
            });
        },
        showModalError: function(){
            this.modalTitle = this.$t('titleErrorRemember');
            this.modalMessage = this.$t('messageErrorRemember');
            this.modalIsError = true;
            this.modalIsLoaded = true;
        },
        showModalOK: function(){
            this.modalTitle = this.$t('titleOkRemember');
            this.modalMessage = this.$t('messageOkRemember');
            this.modalIsError = false;
            this.modalIsLoaded = true;
        },
        loaded: function(){
            this.modalIsError = false;
            this.modalIsLoaded = false;
        },
    },
};



// WEBPACK FOOTER //
// ./src/oblidat/oblidat.js